import { render, staticRenderFns } from "./LocationsManager.vue?vue&type=template&id=79da6977"
import script from "./LocationsManager.vue?vue&type=script&lang=js"
export * from "./LocationsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports